import { Button } from './Button';
import { Buttons as ButtonsComponent, ButtonsMultiple } from './Buttons';

export { ToggleButtonSize } from '../types';
const Buttons = Object.assign(ButtonsComponent, { Button, Multiple: ButtonsMultiple });

export { Button, Buttons, ButtonsMultiple };
